import axios, { AxiosError, AxiosResponse } from 'axios';

/**
 * Настраивает interceptor для axios, который:
 * 1. Перехватывает все исходящие запросы и изменяет значение поля `currency` на указанное.
 * 2. Перехватывает все входящие ответы и изменяет значение поля `currency` на указанное.
 * @param {string} currency - Значение, на которое будет заменено поле `currency`.
 */
export const setupCurrencyInterceptor = (currency: string): (() => void) => {
  try {
    // Перехватчик для исходящих запросов
    const requestInterceptor = axios.interceptors.request.use(
      (config) => {
        if (config?.data?.currency) {
          config.data.currency = currency;
        }
        if (config?.params?.currency) {
          config.params.currency = currency;
        }
        return config;
      },
      (error: AxiosError) => {
        console.error('Ошибка в interceptor:', error);
        return Promise.reject(error);
      }
    );

    const responseInterceptor = axios.interceptors.response.use(
      (response: AxiosResponse) => {
        if (response?.data?.currency) {
          response.data.currency = [currency];
        }
        return response;
      },
      (error: AxiosError) => {
        console.error('Ошибка в interceptor:', error);
        return Promise.reject(error);
      }
    );
    return () => {
      axios.interceptors.request.eject(requestInterceptor);
      axios.interceptors.response.eject(responseInterceptor);
    };
  } catch (error) {
    console.error('Ошибка при настройке interceptor:', error);
    throw error;
  }
};
